import React from 'react';
import { Form, FormGroup, Col, Row, FormControl, ControlLabel, Button, Alert } from 'react-bootstrap';
//import { LinkContainer } from 'react-router-bootstrap';
import { Link, withRouter } from 'react-router-dom';

import axios from 'axios';
import queryString from 'query-string';
import constants from '../util/constants';
import TelephoneNumber from '../CountryPicker';

import LoadingSpinner from '../LoadingSpinner';
import NPPanel from '../NPPanel';
import Banner from '../Banner'

const { API_BASE_URL } = constants;

class Login extends React.Component {
    constructor(props) {
        super(props)

        this.login = this.login.bind(this)
        this.getPortalSettings = this.getPortalSettings.bind(this)
        this.getLoginForm = this.getLoginForm.bind(this);
        this.getOtpForm = this.getOtpForm.bind(this);
        this.getVerifyPhoneForm = this.getVerifyPhoneForm.bind(this);
        this.setCountryCode = this.setCountryCode.bind(this);
        this.setPhoneNumber = this.setPhoneNumber.bind(this);
        this.validNumber = this.validNumber.bind(this);
        this.getConsentForm = this.getConsentForm.bind(this);

        this.state = {
            errorMsg: '',
            loggingIn: false,
            showLoginError: false,
            showLoginInfo: false,
            userName: '',
            portalSettingsBanner: {},
            login: true,
            sendOtp: false,
            verifyPhone: false,
            otp: null,
            phoneNumber: null,
            countryCode: null,
            requireConsent: false,
            consents: [],
            acceptedConsents: []
        }
    }

    componentDidMount() {
        this.getPortalSettings()
    }

    getPortalSettings() {
        const self = this;
        const getBannerSettings = 'Portal/GetBannerSettings';

        axios.get(API_BASE_URL + getBannerSettings)
            .then(res => {
                if (res?.data?.PortalBannerSettings) {
                    self.setState({
                        PortalBannerSettings: res.data.PortalBannerSettings
                    })
                }
            })
            .catch(err => {
                console.error(err)
            });
    }

    setPhoneNumber(number) {
        this.setState({ phoneNumber: number });
    }

    setCountryCode(cc) {
        this.setState({ countryCode: cc });
    }

    validNumber() {
        let regex = /^[0-9 -]+$/g;
        let found = this.state.phoneNumber != null ? this.state.phoneNumber.match(regex) : null;
        return found != null && this.state.countryCode != null && this.state.phoneNumber != null && this.state.phoneNumber.length > 0;
    }


    login(evt) {
        evt.preventDefault();

        const { setApiToken, history } = this.props;
        const { userEmail, userPass, verifyPhone, requireConsent, consents } = this.state;

        const self = this;

        this.setState({
            loggingIn: true,
        });

        let acceptedConsents = requireConsent ? JSON.stringify(consents) : null;


        if (verifyPhone && (this.state.phoneNumber == null || this.state.countryCode == null)) {
            this.setState({
                showLoginError: true,
                errorMsg: "Please enter both a country code and a valid telephone number."
            })
        }
        else {
            axios.post(API_BASE_URL + 'token', queryString.stringify({
                grant_type: 'password',
                username: userEmail,
                password: userPass,
                otp: this.state.otp,
                phoneNumber: this.state.phoneNumber,
                countryCode: this.state.countryCode,
                consentList: acceptedConsents
            }))
                .then(function (response) {
                    setApiToken(response.data.access_token);
                    history.push('/dashboard');
                })
                .catch(function (error) {
                    let message = error && error.response && error.response.data ? error.response.data.error_description : 'Unknown error.';
                    window.sessionStorage.setItem('Grants', []);
                    window.sessionStorage.setItem('UserType', 0);
                    self.setState({
                        errorMsg: message,
                        loggingIn: false,
                        userName: userEmail,
                        showLoginError: false,
                        showLoginInfo: false
                    })
                    let status = error?.response?.data?.error;
                    if (status === 'requested_otp') {
                        self.setState({
                            login: false,
                            sendOtp: true,
                            verifyPhone: false,
                            showLoginInfo: true,
                            requireConsent: false
                        })
                    }
                    else if (status === 'confirm_phone') {
                        self.setState({
                            login: false,
                            sendOtp: false,
                            verifyPhone: true,
                            showLoginInfo: true,
                            requireConsent: false
                        })
                    }
                    else if (status === 'require_consent') {
                        self.setState({
                            login: false,
                            sendOtp: false,
                            verifyPhone: false,
                            showLoginInfo: false,
                            requireConsent: true,
                            consents: error.response.data.errorBody
                        })
                    }
                    else {
                        self.setState({
                            login: true,
                            sendOtp: false,
                            verifyPhone: false,
                            showLoginError: true,
                            otp: null,
                            phoneNumber: null,
                            countryCode: null,
                            requireConsent: false
                        })
                    }
                });
        }
    }

    getLoginForm() {
        return (<Form smoffset={2} sm={8} horizontal onSubmit={evt => { evt.preventDefault(); this.login(); }}>
            <FormGroup controlId="formHorizontalEmail">
                <Col componentClass={ControlLabel} sm={2}>
                    Email
                        </Col>
                <Col sm={10}>
                    <FormControl type="email" placeholder="Email" defaultValue={this.state.userName} onChange={evt => { this.setState({ userEmail: evt.target.value }) }} />
                </Col>
            </FormGroup>

            <FormGroup controlId="formHorizontalPassword">
                <Col componentClass={ControlLabel} sm={2}>
                    Password
                        </Col>
                <Col sm={10}>
                    <FormControl type="password" placeholder="Password" onChange={evt => { this.setState({ userPass: evt.target.value }) }} />
                </Col>
            </FormGroup>

            <FormGroup>
                <Col smOffset={2} sm={8} className="padd-bottom-10">
                    <Link to="/forgotPassword" className="text-primary">
                        Forgot password?
                            </Link>
                </Col>
                <Col smOffset={2} sm={10}>
                    <Button type="submit" bsStyle="primary" onClick={this.login} className="pull-right">
                        Sign in
                            </Button>
                </Col>
            </FormGroup>
        </Form>);
    }

    getOtpForm() {
        return (<Form smoffset={2} sm={8} horizontal onSubmit={evt => { evt.preventDefault(); this.login(); }}>
            <FormGroup controlId="formHorizontalOtp">
                <Col componentClass={ControlLabel} sm={2}>
                    One-time password
                        </Col>
                <Col sm={10}>
                    <FormControl type="text" placeholder="One-time password" onChange={evt => { this.setState({ otp: evt.target.value }) }} />
                </Col>
            </FormGroup>

            <FormGroup>
                <Col smOffset={2} sm={10}>
                    <Button type="submit" bsStyle="primary" onClick={this.login} className="pull-right">
                        Verify
                            </Button>
                    <Button type="submit" bsStyle="primary" onClick={evt => { evt.preventDefault(); this.props.refreshPage && this.props.refreshPage(); }} className="pull-right" style={{ margin: "0 10px" }}>
                        Back
                            </Button>
                </Col>
            </FormGroup>
        </Form>);
    }

    getVerifyPhoneForm() {
        return (<Form smoffset={2} sm={8} horizontal onSubmit={evt => { evt.preventDefault(); this.login(); }}>

            <TelephoneNumber setCc={this.setCountryCode} setNumber={this.setPhoneNumber} countryCode={this.state.countryCode} phoneNumber={this.state.phoneNumber} />

            <FormGroup>
                <Col smOffset={2} sm={10}>
                    <Button type="submit" bsStyle="primary" disabled={this.validNumber() == false} onClick={this.login} className="pull-right">
                        Submit
                            </Button>
                    <Button type="submit" bsStyle="primary" onClick={evt => { evt.preventDefault(); this.props.refreshPage && this.props.refreshPage(); }} className="pull-right" style={{ margin: "0 10px" }}>
                        Back
                            </Button>
                </Col>
            </FormGroup>
        </Form>);
    }

    getConsentForm() {
        return (
            <Form smoffset={2} sm={8} horizontal onSubmit={evt => { evt.preventDefault(); this.login(); }}>
                <FormGroup>
                    <Row>
                        <Col>
                            <div style={{ maxHeight: '30vh', height: '60%', overflow: 'hidden', overflowY: 'auto', wordWrap: 'break-word'}}>
                                <h3>Your consent is required</h3>
                                <span>In order for this website to work, some sensitive data may be required from you. </span>
                                <span>For general information and contact please click <a href='https://www.nordic-paper.com/en/contact/nordic-paper-and-gdpr' target="_blank">here.</a></span>
                            </div>

                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div style={{ maxHeight: '30vh', height: '60%', overflow: 'hidden', overflowY: 'auto', wordWrap: 'break-word', marginBottom: '20px' }}>
                                <ul style={{ paddingLeft: '15px' }}>
                                    {this.state.consents.map((consent) => {
                                        return (
                                            <li key={'consent' + consent.ConsentId} style={{ marginTop: '10px' }}>
                                                <b>{consent.Name}</b><br />
                                                <span>{consent.Message}</span>
                                            </li>
                                        )
                                    })}
                                </ul>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button type="submit" bsStyle="primary" onClick={this.login} className="pull-right">Give consent</Button>
                        </Col>
                    </Row>
                </FormGroup>
            </Form>);
    }

    render() {
        const { showLoginError, showLoginInfo, errorMsg, PortalBannerSettings, login, sendOtp, verifyPhone, requireConsent } = this.state;

        return (
            <div>
                {PortalBannerSettings && PortalBannerSettings.IsActive && <Banner PortalBannerSettings={PortalBannerSettings} />}
                <NPPanel title="Login" small centered>
                    {this.state.loggingIn && <LoadingSpinner isLoading={true} />}

                    {!this.state.loggingIn && <div>
                        {showLoginError && <Alert bsStyle="danger">Error during login: {errorMsg}</Alert>}
                        {showLoginInfo && <Alert bsStyle="info">{errorMsg}</Alert>}

                        {login && this.getLoginForm()}

                        {requireConsent && this.getConsentForm()}

                        {sendOtp && this.getOtpForm()}

                        {verifyPhone && this.getVerifyPhoneForm()}

                    </div>}
                </NPPanel>
            </div>
        );
    }
}

export default withRouter(Login);